import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authProvider from "../../../authProvider";
import { LoadingIcon } from "../../../assets/icons/Icons";
import Logo from "../../../components/Logo";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import "../../../assets/scss/components/login.scss";
import { useThemeContext } from "../../../contexts/ThemeContext";
import { useGlobalContext } from "../../../contexts/GlobalContext";
import { useUserContext } from "../../../contexts/UserContext";
import OTPInput from "../../../components/OtpInput";

function Index(props) {
  const mfaData = JSON.parse(sessionStorage.getItem("mfa_user_sub") || "{}");
  const { t, i18n } = useTranslation();
  const { theme } = useThemeContext();
  const { setIsAuth } = useGlobalContext();
  const { setUserData } = useUserContext();
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otpCode, setOtpCode] = useState(["", "", "", "", "", ""]);
  useEffect(() => {
    if (mfaData && !mfaData.mfa_required) {
      // If MFA is not required, redirect to home
      navigate("/");
    } else if (!mfaData || !mfaData.mfa_required) {
      // If no MFA data found, redirect to login
      navigate("/user/login");
    } else if (mfaData && !mfaData.mfa_registered) {
      // If MFA not registered, redirect to setup
      navigate("/auth/mfa-setup");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mfaData]);
  // Default labels that can be overridden
  const defaultLabels = {
    qrInstruction: i18n.t("qrInstruction"),
    copySecretTooltip: i18n.t("copySecretTooltip"),
    authenticatorApps: i18n.t("authenticatorApps"),
    otpLabel: i18n.t("otpLabel"),
  };

  const handleOTPComplete = (code) => {
    if (!mfaData || !mfaData.session || !mfaData.user_sub) {
      return;
    }
    // onSetupComplete(mfaData.user_sub, mfaData.session, code);
  };

  const handleOTPChange = (newCode) => {
    setOtpCode(newCode);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // rememberMe controls cookie duration
    // No longer storing credentials in localStorage for security

    authProvider
      .mfaVerify({
        user_sub: mfaData.user_sub,
        session: mfaData.session,
        otp: otpCode.join(""),
      })
      .then(({ userData }) => {
        authProvider
          .checkAuth()
          .then(() => {
            // Token is now in httpOnly cookie
            setIsAuth(true);
            setUserData(userData);
            setLoading(false);
            setLoginError("");
            navigate("/");
          })
          .catch(() => {
            setUserData(null);
            setLoading(false);
            setLoginError("Login failed, Authentication invalid!");
          });
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = error.message || "Login failed";
        const errorCode = error.response?.error?.code;
        setLoginError(errorCode ? `errors_${errorCode}` : errorMessage);
      });
  };
  const handleLogout = () => {
    // Clear MFA session data
    sessionStorage.removeItem("mfa_user_sub");
    authProvider.logout();
    navigate("/user/login");
  };
  return (
    <div>
      <div className="mt-3 text-center">
        <Logo
          className="logo"
          src={theme?.logo}
          style={{ maxWidth: "200px", objectFit: "contain" }}
        />
      </div>
      <div className="login">
        <div className="pl-3 pr-3">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <LanguageSwitcher />
          </div>
          <div className="mt-3 text-center">
            <h3 className="mb-4">
              {t("Verify MFA for")} {t(`${theme?.copyright_company_name}`)}
            </h3>
          </div>
          <form
            action=""
            method="post"
            className="mb-2"
            onSubmit={handleSubmit}
          >
            <div className="row mb-2">
              <div className="col-xs-12">
                <label htmlFor="otp">{t(defaultLabels.otpLabel)}</label>
                <div className="input-wrapper">
                  {/* OTP Input Component */}
                  <OTPInput
                    value={otpCode}
                    onChange={handleOTPChange}
                    onComplete={handleOTPComplete}
                  />
                </div>
              </div>
            </div>
            <button
              className={`btn btn-primary mb-2 ${loading ? "btn-loading" : ""}`}
              style={{ width: "100%" }}
              type="submit"
              name="submit"
              disabled={loading || otpCode.includes("")}
            >
              {loading && <LoadingIcon />}
              {i18n.t("Verify")}
            </button>
            <button
              className="btn btn-link btn-medium"
              style={{ width: "100%", color: "#212121" }}
              type="button"
              name="cancel"
              onClick={handleLogout}
            >
              {i18n.t("Back to login")}
            </button>{" "}
            {loginError && (
              <div className="text-center">
                <span className="form-error">{i18n.t(loginError)}</span>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Index;
